// This is to allow "outlines" on safari 15+
export const createOutlineStyle = (width: number, color: string, offset = 0) => {
  return {
    position: 'relative' as const,
    '&::before': {
      width: 'auto !important',
      content: '""',
      position: 'absolute' as const,
      top: -offset,
      left: -offset,
      right: -offset,
      bottom: -offset,
      boxShadow: `0 0 0 ${width}px ${color}`,
      borderRadius: 'inherit',
    },
  }
}

// On Safari 15/16 dvh returns a value that is larger than the viewport/
// Adding a maxHeight with "lvh" fixes this, which seems to be a bug with Safari
export const dvhSafeStyle = (style: string) => {
  const hasDvh = style.includes('dvh')
  if (!hasDvh) {
    console.error('no dvh found in style', style)
  }

  return {
    height: style,
    maxHeight: style.replace('dvh', 'lvh'),
  }
}